import createReactComponent from '../createReactComponent';
export default createReactComponent('copyleft', 'IconCopyleft', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  [
    'path',
    {
      d: 'M10 9.75a3.016 3.016 0 0 1 4.163 .173a2.993 2.993 0 0 1 0 4.154a3.016 3.016 0 0 1 -4.163 .173',
      key: 'svg-1',
    },
  ],
]);
